import React from 'react';

import GroupsIcon from '@mui/icons-material/Groups';
import { Avatar, Box, CircularProgress, Tooltip, Typography } from '@mui/material';

import GlobalCard from './GlobalCard';
import { CommonNode } from '../types/networking';

type Props = {
  connections: CommonNode[];
  loading: boolean;
};

const ConnectionsCard: React.FC<Props> = ({ connections, loading }) => {
  const maxAvatars = 7;
  const extraCount = connections.length > maxAvatars ? connections.length - maxAvatars : 0;

  return (
    <GlobalCard icon={<GroupsIcon />} title={`Conexões em Comum (${connections.length})`}>
      {loading ? (
        <CircularProgress size={20} />
      ) : (
        <Box display="flex" alignItems="center" justifyContent="center" gap={1} mt={4}>
          {connections.slice(0, maxAvatars).map((conn, idx) => (
            <Tooltip title={conn.name}>
              <Avatar
                key={conn.id}
                src={conn.photo_url}
                alt={conn.name}
                sx={{ width: 48, height: 48 }}
              />
            </Tooltip>
          ))}
          {extraCount > 0 && <Typography variant="h6">+{extraCount}</Typography>}
          {connections.length === 0 && (
            <Typography variant="subtitle1" color="text.secondary" mt={2}>
              Nenhuma conexão em comum
            </Typography>
          )}
        </Box>
      )}
    </GlobalCard>
  );
};

export default ConnectionsCard;
